import { render, staticRenderFns } from "./practicalMarksEntry.vue?vue&type=template&id=286d1afd&"
import script from "./practicalMarksEntry.vue?vue&type=script&lang=js&"
export * from "./practicalMarksEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports